import CUBTypeDonut from '../../cu-boulder/charts/TypeDonut';


export default class TypeDonut extends CUBTypeDonut {

    static selectedOnLoad = false;

}
